
import { computed, defineComponent } from 'vue'
import Modal from '@/components/modals/Modal.vue'

export default defineComponent({
	name: 'CloseTabModal',

	emits: ['close'],

	components: { Modal },

	props: {
		isLoading: {
			type: Boolean,
			default: false
		},

		firstButtonAction: {
			type: Function,
			default: () => {}
		},

		secondButtonAction: {
			type: Function,
			default: () => {}
		},

		darkTheme: {
			type: Boolean,
			default: false
		},

		cancelingTab: {
			type: Boolean,
			default: false
		}
	},

	setup(props, { emit }) {
		const closeModal = () => {
			emit('close')
		}

		const dynamicProps = computed(() => {
			return props.cancelingTab
				? {
						title: 'Cancel Order?',
						firstButtonText: 'Keep Order',
						secondButtonText: 'Yes, Cancel Order'
				  }
				: {
						title: 'Are you sure?',
						firstButtonText: 'Keep Open',
						secondButtonText: 'Close Smarttab'
				  }
		})

		return {
			closeModal,
			dynamicProps
		}
	}
})
